import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TimerBar = function (_a) {
    var timeRemainingPercentage = _a.time_remaining_percentage, timeRemainingString = _a.time_remaining_string;
    var width = timeRemainingPercentage;
    if (width === 0) {
        return (_jsx("div", {}));
    }
    var timerColor = 'green';
    if (width >= 90) {
        timerColor = 'red';
    }
    var classes = "sb-game-timer-bar timer-".concat(timerColor);
    var style = {
        width: "".concat(width, "%")
    };
    return (_jsx("div", { className: classes, style: style, children: _jsxs("span", { className: "game-card-timer", children: [_jsx("i", { className: "icon ion-clock" }), ' ', timeRemainingString] }) }));
};
export default TimerBar;
